import { render } from "./BalanceSummary.vue?vue&type=template&id=5fde7ea0&scoped=true&bindings={\"option\":\"data\",\"dateRange\":\"options\",\"expenseItemsFiltered\":\"options\",\"investmentItemsFiltered\":\"options\",\"incomeItemsFiltered\":\"options\",\"totalExpenses\":\"options\",\"totalInvestments\":\"options\",\"totalIncome\":\"options\",\"totalBalance\":\"options\",\"values\":\"options\",\"plot\":\"options\"}"
import script from "./BalanceSummary.vue?vue&type=script&lang=js"
export * from "./BalanceSummary.vue?vue&type=script&lang=js"

import "./BalanceSummary.vue?vue&type=style&index=0&id=5fde7ea0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fde7ea0"

export default script